export default "__VITE_ASSET__DNqprEca__"